// Loqate integration with gravity forms - https://www.loqate.com/developers/guides/advanced-setup-guide/
// CDN links need to be served over http if developing locally

const PostcodeLookup = {
    init() {

        this.loadLoqateScript().then(() => {
            if (typeof pca === 'undefined') {
                return;
            }

            // Define fields - this is where loqate is bound to
            const fields = [
                { element: "input_1_5_5", field: "PostalCode" }
            ];

            // Loqate config options
            const options = {
                key: "ZF34-UH59-KB12-MB59",
                countries: { codesList: "GBR" },
                setCountryByIP: true,
                GeoLocationEnabled: true,
                GeoLocationRadius: 50,
                GeoLocationMaxItems: 10
            };

            // Initialize the address control - this gives us the address object
            const control = new pca.Address(fields, options);

            control.listen("populate", (address, variations) => {
                const hiddenFields = document.querySelector('.loqate-hidden-fields');

                if (hiddenFields) {
                    hiddenFields.style.maxHeight = hiddenFields.scrollHeight + "px";
                }

                document.getElementById("input_1_8_1").value = address.Line1;
                document.getElementById("input_1_8_2").value = address.Line2;
                document.getElementById("input_1_8_3").value = address.City;
                document.getElementById("input_1_8_5").value = address.PostalCode;
            });

        }).catch(error => {
            console.error('Error loading Loqate script:', error);
        });
    },

    loadLoqateScript() {
        return new Promise((resolve, reject) => {
            if (document.querySelector('script[src="https://services.postcodeanywhere.co.uk/js/address-3.97.js"]')) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.src = 'https://services.postcodeanywhere.co.uk/js/address-3.97.js';
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Failed to load the Loqate script'));
            document.head.appendChild(script);
        });
    }
}

export default PostcodeLookup;

// Loqate hidden fields visibility
document.addEventListener('DOMContentLoaded', () => {    
    const descriptionElement = document.querySelector('.js-enter-address-manually-label .gfield_description');

    if (descriptionElement) {
        descriptionElement.addEventListener('click', () => {
            const hiddenFields = document.querySelector('.loqate-hidden-fields');

            if (hiddenFields.style.maxHeight) {
                hiddenFields.style.maxHeight = null;
            } else {
                hiddenFields.style.maxHeight = hiddenFields.scrollHeight + "px";
            }
        });
    }

    // Hide register-label on successful form submission using jQuery and AJAX handling
    jQuery(document).on('gform_post_render', function(event, formId) {
        PostcodeLookup.init();

        jQuery(document).on('gform_confirmation_loaded', function() {
            const registerLabel = document.querySelector('.register-label');
            const welcomeheading = document.querySelector('.welcome-heading');
            const healthCheckDescription = document.querySelector('.health-check-description');

            if (registerLabel) {
                registerLabel.style.display = 'none';
            }

            if (welcomeheading) {
                welcomeheading.style.display = 'none';
            }

            if (healthCheckDescription) {
                healthCheckDescription.style.display = 'none';
            }
        });
    });
});